import { requireField } from './validators';

export default class Contact {
  constructor(data = {}) {
    requireField(data.name, 'contact.name');
    requireField(data.role, 'contact.role');

    this.id = data.id || `con-${Math.random().toString(36).slice(2, 9)}`;
    this.type = data.type || 'guardian';
    this.name = data.name;
    this.role = data.role;
    this.phone = data.phone || '';
    this.email = data.email || '';
    this.notes = data.notes || '';
  }

  toJSON() {
    return { ...this };
  }
}
